export const state = () => ({
    languages: [],
});
